import type { SVGProps } from "react";
export interface SpatulaIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SpatulaIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SpatulaIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.925 1.497c.827-.7 2.01-.824 2.971-.29l1.012.562.337.195a11.1 11.1 0 0 1 3.986 4.126l.563 1.014.098.195c.446.988.24 2.16-.536 2.937l-4.729 4.727a3.12 3.12 0 0 1-2.862.847l-.205-.052-.683-.194a1.87 1.87 0 0 0-1.832.47l-6.348 6.274a2.833 2.833 0 0 1-3.779.181l-.214-.193a2.83 2.83 0 0 1-.011-3.993l6.273-6.347.166-.19c.3-.398.43-.902.357-1.397l-.052-.246-.195-.683a3.12 3.12 0 0 1 .795-3.067l4.727-4.728zm1.53 1.667-.1.071-4.727 4.729a.87.87 0 0 0-.223.858l.195.683.068.27a4.13 4.13 0 0 1-1.1 3.763l-6.274 6.347a.58.58 0 0 0 .001.82l.09.073a.58.58 0 0 0 .73-.071l6.348-6.274a4.13 4.13 0 0 1 4.032-1.033l.683.195.116.025a.87.87 0 0 0 .742-.248l4.729-4.727.072-.1a.38.38 0 0 0 .032-.232l-.041-.116-.564-1.014a8.9 8.9 0 0 0-2.917-3.127l-.53-.32-1.014-.564a.38.38 0 0 0-.348-.008"
      />
      <path
        fill={color}
        d="M16.705 7.704a1.125 1.125 0 0 1 1.591 1.591l-2.001 2.001a1.125 1.125 0 0 1-1.59-1.59zm-2-2a1.125 1.125 0 0 1 1.59 1.591l-2 2a1.125 1.125 0 1 1-1.59-1.59l2-2Z"
      />
    </svg>
  );
}
